import styled from 'styled-components';

export const Counter = styled.div<{ isError: boolean }>`
  font-family: 'Inter';
  position: absolute;
  top: 5px;
  right: 10px;
  font-size: 12px;
  color: ${({ isError }) => (isError ? 'red' : 'gray')};
`;
